// Actions
export const GET_POST_DATA_FROM_REFERENCE = 'GET_POST_DATA_FROM_REFERENCE'
export const UPDATE_POSTS_DATES = 'UPDATE_POSTS_DATES'
export const RESET_POSTS_ACTION = 'RESET_POSTS_ACTION'
export const GET_NEXT_POSTS = 'GET_NEXT_POSTS'
export const MERGE_POST = 'MERGE_POST'

// Mutations
export const REFRESH_POSTS_PUBLISHED_AT = 'REFRESH_POSTS_PUBLISHED_AT'
export const UPDATE_POSTS_PUBLISHED_AT = 'UPDATE_POSTS_PUBLISHED_AT'
export const UPDATE_POST_REF = 'UPDATE_POST_REF'
export const MERGE_POST_DATA = 'MERGE_POST_DATA'
export const DELETE_POST = 'DELETE_POST'
export const RESET_POSTS = 'RESET_POSTS'
export const ADD_POST_REF = 'ADD_POST_REF'
export const SET_POST_DATA = 'SET_POST_DATA'



// WEBPACK FOOTER //
// ./src/store/actions/postQueries.js